/**
 * URLs for backend file downloads (signed PDFs and the like).
 *
 * Downloads are plain links, not `APIAgent.request` calls: the browser sends
 * the session cookie itself, and the file opens in its own tab. A relative API
 * path only needs the API origin in front of it when the frontend and API are
 * served from different origins (`REACT_APP_API_URL`); otherwise
 * `API_BASE_URL` is empty and the path stays same-origin.
 */

import { API_BASE_URL } from '../agents/apiAgent';

/**
 * Resolve a download path from the API into a URL for an `<a href>`.
 *
 * @param {string} url - an API path (`/api/documents/1/download`) or an
 *   absolute URL, which is returned unchanged
 * @returns {string} the URL, or '' when there is nothing to download
 */
export const resolveDownloadUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${API_BASE_URL}${url}`;
};

export default resolveDownloadUrl;
